import { useUser } from "@auth0/nextjs-auth0/client";

enum AdministratorRoles {
  GlobalAdmin = "Global Administrator",
  LocalAdmin = "Local Administrator",
}

enum UserRoles {
  AllowNSFW = "Allow NSFW",
}

const ROLES_NAMESPACE = "https://app.pyrratech.com/roles";

export const useRoles = (): string[] => {
  const { user } = useUser();
  return (user?.[ROLES_NAMESPACE] as string[]) || [];
};

export const useGlobalAdmin = (): boolean => {
  const roles = useRoles();
  return roles.includes(AdministratorRoles.GlobalAdmin);
};

export const useOrgAdmin = (): boolean => {
  const { user } = useUser();
  const isGlobalAdmin = useGlobalAdmin();
  const isEmailOrgAdmin =
    user?.email?.toLowerCase().endsWith("@alertmedia.com") ?? false;

  return isEmailOrgAdmin || isGlobalAdmin;
};

export const useAllowNSFW = (): boolean => {
  const roles = useRoles();
  return roles.includes(UserRoles.AllowNSFW);
};
